// eslint-disable-next-line
export const transformArrayToObjs = (array, propertyName = 'uuid') => Object.values(array).reduce((obj, row) => ((obj[row[propertyName]] = row), obj), {})

// eslint-disable-next-line
export const removeByUuid = (objs, uuid) => transformArrayToObjs(Object.values(objs).filter(obj => obj.uuid !== uuid))
